var map = {
	"./5stars-forex.png": "3fda",
	"./aas-pass-logo.png": "52fd",
	"./android.png": "dc16",
	"./astasks.png": "134e",
	"./choose-your-forex-logo.png": "b514",
	"./cloudfiles-logo.png": "3ef2",
	"./facebook.png": "af94",
	"./instagram.png": "f6ee",
	"./linkedin.png": "72eb",
	"./mailchimp.png": "5255",
	"./multimedia-typing-guide.jpg": "7f03",
	"./nritana-edutainment-for-student.jpg": "3d78",
	"./nritana-encyclopedia-of-nepal.jpg": "ce0f",
	"./psd.png": "c056",
	"./table-tennis-game.jpg": "1446",
	"./thrive_logo.png": "1fc5",
	"./tigerflo.png": "a132",
	"./twitter.png": "141c",
	"./xd.png": "7f8b",
	"./youtube-play.svg": "8cba",
	"./youtube.png": "3234"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed22";